import React from 'react';
import {useLocation} from 'react-router-dom';

const ADTEventsDetails = () => {
  const {state} = useLocation();
  const {body} = state || {};
  let displayData = {};

  try {
    if (typeof body === 'string') {
      displayData = JSON.parse(body);
    } else if (typeof body === 'object' && body !== null) {
      displayData = body;
    }
  } catch (error) {
    return <pre>Error parsing JSON: {error.message}</pre>;
  }

  return <pre>{JSON.stringify(displayData, null, 2)}</pre>;
};

export default ADTEventsDetails;
